import Kimchi from '../assets/kimchi.jpg';
import Ramen from "../assets/ramen.jpg";
import Briyani from '../assets/briyani.jpg'
import kebab from '../assets/kebab.jpg'
import SpicyPasta from '../assets/spicy-pasta.jpg'
import Panneer from '../assets/paneer-butter-masala.jpg'


export const MenuList = [
  {
    name: "Briyani",
    image: Briyani,
    price: 1300,
  },
  {
    name: "Kimchi",
    image: Kimchi,
    price: 1000,
  },
  {
    name: "Seafood Ramen",
    image: Ramen,
    price: 1000,
  },
  
  {
    name: "Kebab",
    image: kebab,
    price: 900,
  },
  {
    name: "Spicy Pasta",
    image: SpicyPasta,
    price: 1100,
  },
  {
    name: "Paneer Masala",
    image: Panneer,
    price: 1400,
  },
];
